import { TextInput } from "react-admin";

export const GoogleLsaSourceConfig: React.FC = () => {
  return (
    <TextInput
      label="Google Ads Customer ID"
      source="source.customerId"
      fullWidth
      required
      helperText="10-digit Google Ads customer ID for the Local Services account. Dashes are optional."
    />
  );
};
